const Sage = window.Sage;

import Form from '@js/components/form';

export default {
  init() {
    this.events();
  },

  events() {
    $('.edit-account-form').on('submit', (e) => {
      e.preventDefault();

      const formEl = $(e.currentTarget);

      formEl.addClass('loading');

      if (Form.validate(formEl)) {
        this.submit(formEl);
      } else {
        formEl.removeClass('loading');
      }
    });
  },

  submit(formEl) {
    const formData = new FormData(formEl[0]);

    $.ajax({
      url: Sage.ajaxurl,
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
    }).done((response) => {
      console.log(response);
      window.location.reload();
    });
  },
};
